import type { User } from '../types'

/** Správce IT / budov, hlavní ekonom, ředitel — všechny role docházky. */
export function isAttendanceOversightUser(
  user: Pick<User, 'role' | 'admin_type'> | null | undefined,
): boolean {
  if (!user?.role) return false
  if (user.role === 'admin' && (user.admin_type === 'spravce_it' || user.admin_type === 'spravce_budov')) {
    return true
  }
  if (user.role === 'director' || user.role === 'financist') return true
  return false
}
